
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 13 15"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10.833 3.753h-.252a2.688 2.688 0 00-.174-2.592A2.543 2.543 0 009.262.193a2.434 2.434 0 00-1.47-.136A2.497 2.497 0 006.5.799C6.15.423 5.7.164 5.208.057a2.434 2.434 0 00-1.47.136 2.542 2.542 0 00-1.145.968 2.689 2.689 0 00-.174 2.592h-.252c-.575 0-1.126.237-1.532.659A2.294 2.294 0 000 6.002v1.5c0 .199.076.39.212.53.135.14.319.22.51.22h.722v4.499c0 .596.229 1.168.635 1.59.406.422.957.659 1.532.659H9.39c.575 0 1.126-.237 1.532-.659.406-.422.635-.994.635-1.59v-4.5h.722a.71.71 0 00.51-.219.765.765 0 00.212-.53v-1.5c0-.596-.228-1.168-.635-1.59a2.127 2.127 0 00-1.532-.66zM5.778 13.5H3.61a.71.71 0 01-.51-.22.765.765 0 01-.212-.53V8.253h2.889V13.5zm0-6.748H1.444v-.75c0-.199.077-.39.212-.53s.32-.22.51-.22h3.612v1.5zm0-3H4.694c-.214 0-.423-.065-.601-.189a1.117 1.117 0 01-.4-.504 1.165 1.165 0 01-.061-.65c.042-.218.145-.419.296-.576.152-.157.345-.265.555-.308.21-.043.428-.021.626.064s.367.23.486.414c.12.185.183.403.183.625v1.125zm1.444-1.124c0-.222.064-.44.183-.625s.288-.329.486-.414c.198-.085.416-.107.626-.064.21.043.403.15.555.308a1.165 1.165 0 01.235 1.226c-.083.205-.221.38-.4.504-.178.124-.387.19-.601.19H7.222V2.628zm2.89 10.123c0 .198-.077.39-.212.53a.71.71 0 01-.511.22H7.222V8.25h2.89v4.5zm1.444-5.999H7.222v-1.5h3.611c.192 0 .376.08.511.22.136.14.212.331.212.53v.75z"}})])
          )
        }
      }
    